export default __webpack_public_path__ + "static/media/queue-outline-selected.2f12b4b3.svg";